<template>
  <v-card
    class="mx-4 my-4"
    outlined
  >
    <FavouritesButton
      :item="opportunity"
    />

    <div
      class="opportunity__link"
      ripple
    >
      <v-list-item three-line>
        <v-list-item-content @click="handleContentClick($event)">
          <router-link
            :to="{ name: 'Opportunity', params: { id: opportunity.id }}"
            class="opportunity__link"
            ripple
          >
            <v-list-item-title class="headline "><p>{{opportunity.name}}</p></v-list-item-title>
          </router-link>

          <v-list-item v-if="opportunity.company !== null">
            <v-list-item-icon>
              <v-icon color="primary">mdi-briefcase</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-subtitle>{{hubbdata.apprenticeship.labels.employer}}</v-list-item-subtitle>
              <v-list-item-title>{{opportunity.company}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="opportunity.location !== null">
            <v-list-item-icon>
              <v-icon color="primary">mdi-map-marker</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-subtitle>{{hubbdata.apprenticeship.labels.location}}</v-list-item-subtitle>
              <v-list-item-title>{{opportunity.location}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="opportunity.closing_date !== null">
            <v-list-item-icon>
              <v-icon color="primary">mdi-calendar-range</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-subtitle>{{hubbdata.apprenticeship.labels.closingdate}}</v-list-item-subtitle>
              <v-list-item-title>{{opportunity.closing_date | formatDate}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list-item-content>
      </v-list-item>

      <v-card-actions>
        <v-btn
          class="v-btn--outlined white--text"
          :to="{ name: 'Opportunity', params: { id: opportunity.id }}"
          text
        >
          {{hubbdata.catagories.info}}
      </v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
import hubbdata from "@/hubbdata";
import FavouritesButton from '@/components/Favourites/FavouritesButton.vue';
import moment from 'moment';

export default {
  name: 'OpportunityItem',
  props: {
    opportunity: Object,
  },
  components: {
    FavouritesButton
  },
  computed: {
    hubbdata() {
      return hubbdata.getters.translations;
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY');
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.event {

  img {
    max-width: 100%;
    width: 100%;
  }
}

.v-btn--outlined {
  text-transform: capitalize;
  margin: 0 auto;
  background-color: #90cae8!important;
  outline: none!important;
  color: $dark!important;
  font-weight: 18px;
  text-transform: capitalize;
  font-weight: bold;

  @media screen and (min-width: 960px) {
    font-size: 16px;
  }
}

.v-list-item__icon {
  margin: 16px 32px 0px 0px !important;
}

.headline {
  margin-right: 60px;
  white-space: normal;
  color: $primary !important;
  font-size: 22px;
}

.opportunity__link {
  text-decoration: none !important;

  .v-list-item__title,
  .v-list-item__subtitle {
    text-overflow: unset;
    white-space: unset;
  }

  .v-card__actions {
    @media (max-width: 576px) {
      display: flex;
      justify-content: center;
    }

    @media (min-width: 577px) {
      margin-left: 8px;
    }
  }

  .email {
    width: 165px;
    white-space: normal;
  }
}
</style>